// extracted by mini-css-extract-plugin
module.exports = {"titleInput":"EditableLookBoardHeader_titleInput__3jk51","editBtn":"EditableLookBoardHeader_editBtn__1exKJ"};